import './App.css';
import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useSwipeable } from 'react-swipeable';




function Page ({ text, note, image, isCurrent, onClick }) {

  const isMobile = useMediaQuery({ query: `(max-width: 1132px)` });

  return (
    <div className='page' isCurrent={isCurrent} style={{display: isCurrent ? 'flex' : 'none', opacity: isCurrent ? '1' : '0'}}>
      <div className='text-column'>{text}</div>
      <div className='image-column'>
        <div className='frame'><img style={{width: '100%', aspectRatio: '1440 / 900', cursor: 'pointer'}} src={image} alt="Image" onClick={onClick}></img></div>
        <div className='note'>{note}</div>
      </div>
    </div>
  );
}


export default Page